import { traitCategories } from "config/categories";
import React from "react";

export const traitsByCategoryDefaultValue: Record<string, number[]> =
  traitCategories.reduce(
    (acc, category) => ({
      ...acc,
      [category]: [],
    }),
    {}
  );

export type DressingRoomContextValue = {
  currentTraits: number[];
  originalTraits: number[];
  availableTraits?: number[];
  availableTraitsByCategory?: typeof traitsByCategoryDefaultValue;
  changedTraits?: number[];
  canRedo: boolean;
  canUndo: boolean;
  undoSwap: () => void;
  redoSwap: () => void;
  resetTraits: () => void;
  removeTrait: (traitId: number) => void;
  swapTrait: (newTraits: number[]) => void;
};

const DressingRoomContext = React.createContext<DressingRoomContextValue>({
  currentTraits: [],
  originalTraits: [],
  canRedo: false,
  canUndo: false,
  undoSwap: () => {},
  redoSwap: () => {},
  resetTraits: () => {},
  swapTrait: () => {},
  removeTrait: () => {},
});

export default DressingRoomContext;
